<form [formGroup]="formGroup" class="input-group" (ngSubmit)="doSearch()"
    [ngClass]="searchResponse?.page?.content?.length || searchResponse?.page?.empty ? 'search-dropdown-open' : ''">
    <input type="text" autocomplete="off" class="form-control" i18n-placeholder="@@UnesitePojamZaPretragu" placeholder="Unesite pojam za pretragu"
        name="search" formControlName="searchInput">
    <div class="input-group-append">
        <button type="submit" aria-label="Search" mat-flat-button color="primary" class="search-button">
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" fill="white">
                <path
                    d="M316.87,298.36l-70.08-70.08a98.74,98.74,0,1,0-20.22,20.22l70.08,70.08a14.3,14.3,0,0,0,20.22-20.22ZM81,169.4A86.65,86.65,0,1,1,167.69,256,86.75,86.75,0,0,1,81,169.4Z" />
            </svg>
        </button>
    </div>
    <pdp-search-results (navigatedToResultOutput)="closeDropdown($event)" [searchResults]="searchResponse">
    </pdp-search-results>
</form>